import script from "./ComputeWizardFriction.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardFriction.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardFriction.vue?vue&type=style&index=0&id=523a33fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523a33fd"]])

export default __exports__